import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import { formatGraphqlErrors } from 'utils/helpers';
import { RecalculateAllProjectsDocument } from 'graphql/generated/graphql';

const useRecalculateAllProjects = () => {
  const [recalculateAllProjects] = useMutation(RecalculateAllProjectsDocument);

  const handleRecalculate = useCallback(async () => {
    try {
      await recalculateAllProjects();
    } catch (error) {
      throw formatGraphqlErrors(error);
    }
  }, [recalculateAllProjects]);

  return handleRecalculate;
};

export default useRecalculateAllProjects;
